import Vue from 'vue';
import App from './App';

/* eslint-disable no-new */
new Vue({
  el: 'body',
  components: { App },
});



/** WEBPACK FOOTER **
 ** ./src/main.js
 **/